var map = {
	"./avatar-helen-base-full.png": 28921,
	"./avatar-helen-fall-full.png": 70065,
	"./avatar-helen-spring-full.png": 41309,
	"./avatar-helen-summer-full.png": 71125,
	"./avatar-helen-travel-full.png": 2100,
	"./avatar-helen-winter-full.png": 80861
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38792;